import { useTranslation } from 'react-i18next'
import { Text, Box, IconErrorOutline } from '@machobear/design-system'
import { InsightBlock } from '../insight-block'

export const PriceError = () => {
  const { t } = useTranslation()

  return (
    <InsightBlock
      icon={<IconErrorOutline tone="critical" size="small" />}
      testId="listing-price-insight"
    >
      <Box display="flex" flexDirection="column" justifyContent="center" style={{ height: '21px' }}>
        <Text weight="medium">{t('Rental price insights unavailable')}</Text>
      </Box>
      <Text>
        {t(
          'Sorry, we don’t have enough data to compare your price. Explore similar listings nearby for reference.'
        )}
      </Text>
    </InsightBlock>
  )
}
